import { httpPost, httpDownload } from '../../../../utils/api.utils';
import {
    setCircuitHistoryLogsLoading,
    getCircuitHistoryLogs,
    setCircuitHistoryPageSize,
    resetCircuitHistory,
    setCircuitHistoryColSearchStr
} from '../../../../constants/model-reducers/external/inventory/circuit-details/history/circuit-history.settings';

import { DEFAULT_TABLE_RESULT_MODEL } from '../../../../constants/external-constants';
import Moment from 'moment';
import { convertToFormatLocalDate, convertToFormatTimeZoneDate } from '../../../../utils/helpers.utils';

const defaultState = () => ({
    HistoryTable: DEFAULT_TABLE_RESULT_MODEL,
    IsLoadingTable: false
});

const initialState = defaultState();

export const circuitHistoryActions = {
    getCircuitHistoryLogs: (circuitId, pageIndex = 0) => async (dispatch, state) => {
        const { Pagination, Headers } = state().inventoryCircuitHistory.HistoryTable;
        var formData = {
            CircuitID: circuitId,
            PageIndex: pageIndex,
            PageSize: Pagination.PerPage,
            PageSizes: Pagination.PageSizes,
            Headers: Headers
        };

        dispatch({
            type: setCircuitHistoryLogsLoading,
            isLoadingTable: true
        });

        var result = await httpPost("external/inventory/getCircuitHistoryLogs", formData);

        const formattedItems = result.Data.Items.map(item => {
            const formattedItem = { ...item };
            Object.keys(formattedItem).forEach(key => {
                if (key === 'OldValue' || key === 'NewValue') {
                    const objectName = formattedItem['Object'];
                    const value = formattedItem[key];
                    if ((objectName === 'MRC' || objectName === 'Percent' || objectName === 'Price') && !isNaN(value)) {                   
                        const num = parseFloat(value);
                        if (Number.isInteger(num) || String(value).endsWith('.0000')) {
                            formattedItem[key] = num.toFixed(2);
                        }
                    }
                }
            });
            return formattedItem;
        });

        dispatch({
            type: getCircuitHistoryLogs,
            historyTable: {
                ...result,
                Data: {
                    ...result.Data,
                    Items: formattedItems,
                },
            },
            isLoadingTable: false
        });
    },
    resizeCircuitHistoryLogs: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setCircuitHistoryPageSize,
            pageSize: parseInt(pageSize),
        });
    },
    setCircuitHistoryColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { HistoryTable } = state().inventoryCircuitHistory;
        var historyTableHeaderUpd = {
            ...HistoryTable,
            "Headers": {
                ...HistoryTable.Headers,
                [key]: {

                    ...HistoryTable.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setCircuitHistoryColSearchStr,
            historyTable: historyTableHeaderUpd
        });
    },
    extractCircuitHistoryLogs: (circuitId) => async (dispatch, state) => {
        const { Headers } = state().inventoryCircuitHistory.HistoryTable;
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;

        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');
        var filename = `ATEM Circuit History – ${formattedTimeZoneDate}`;

        var formData = {
            CircuitID: circuitId,
            Headers: Headers,
            FileName: filename
        };

        httpDownload('external/inventory/getExtractCircuitHistoryLogs', formData)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },
    resetCircuitHistory: () => (dispatch, state) => {
        dispatch({
            type: resetCircuitHistory
        })
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setCircuitHistoryLogsLoading:
            return {
                ...state,
                IsLoadingTable: action.isLoadingTable
            }
        case getCircuitHistoryLogs:
            return {
                ...state,
                HistoryTable: action.historyTable,
                IsLoadingTable: action.isLoadingTable
            }
        case setCircuitHistoryPageSize:
            return {
                ...state,
                HistoryTable: {
                    ...state.HistoryTable,
                    Pagination: {
                        ...state.HistoryTable.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setCircuitHistoryColSearchStr:
            return {
                ...state,
                HistoryTable: action.historyTable,
            }
        case resetCircuitHistory:
            return initialState;
        default:
            return state;
    }
}